// Las notas de versión son archivos estáticos generados en el build
// (tools/build-novedades.js) bajo /novedades. No pasan por el backend ni por axios:
// no necesitan token ni el header de tenant. Mismo criterio que guiasService.

function urlNovedades(ruta) {
    const base = process.env.BASE_URL || '/';
    return `${base}${ruta}`;
}

async function leerJson(ruta) {
    const respuesta = await fetch(urlNovedades(ruta), { cache: 'no-cache' });
    if (!respuesta.ok) {
        throw new Error(`No se pudo cargar ${ruta} (${respuesta.status})`);
    }
    return respuesta.json();
}

export default {
    getIndice() {
        return leerJson('novedades/index.json');
    },
    getVersion(slug) {
        // El slug sale del índice, pero se valida igual para no armar rutas arbitrarias.
        if (!/^[a-z0-9-]+$/.test(slug || '')) {
            return Promise.reject(new Error('Versión inválida'));
        }
        return leerJson(`novedades/${slug}.json`);
    },
};
